import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { ethers } from 'ethers'
import { getAllPoolsContext } from '../../contexts/raidContext';
import {getWalletBalances} from '../../utilities/getWalletBalances'
import { trackPromise } from 'react-promise-tracker';

export interface WalletState {
    status: 'idle' | 'loading' | 'failed';
    allInfo: any;
  }
  
  const initialState: WalletState = {
    status: 'idle',
    allInfo: {},
  };

export const fetchWallet = createAsyncThunk(
    'wallet/fetchWallet',
    
    async (address: string) => {
        const newObj = await trackPromise(getWalletBalances(address))
        const contractCallResponse = await trackPromise(getAllPoolsContext(address))
        const stakedArray:any = []
        const arrayOfAllocations = contractCallResponse.results.getAllocationAmounts.callsReturnContext
        arrayOfAllocations.map(async (returnObj) => {
            const allocationAmount = ethers.utils.formatEther(returnObj.returnValues[0])
            if (allocationAmount !== '0.0'){
                newObj[returnObj.methodParameters[0]] = {...newObj[returnObj.methodParameters[0]], stakeAllocationAmount: allocationAmount}
                const poolIndex = returnObj.methodParameters[0]
                stakedArray.push(poolIndex)
            }
        })
        return newObj
    }
  );

  export const walletSlice = createSlice({
    name: 'wallet',
    initialState,
    reducers:{

    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchWallet.pending, (state) => {
            state.status = 'loading';
          })
          .addCase(fetchWallet.fulfilled, (state, action) => {
            state.status = 'idle';
            state.allInfo = action.payload;
          })
      },
})

export const selectWallet = (state: RootState) => state.wallet;

export default walletSlice.reducer